/**
 * Shared sidebar dimensions for the Mission Control TwoColumnLayout.
 *
 * Tailwind reads classes statically, so each width has both a class string
 * (consumed via cn / className) and a raw value (consumed by JS that sets the
 * `--two-column-header-offset` CSS variable or computes margins inline).
 *
 * Adjust the percentages here to retune the layout in one place.
 */

/** Mobile sidebar width (overlay). */
export const SIDEBAR_WIDTH_MOBILE = '280px';

/** Desktop expanded sidebar width. */
export const SIDEBAR_WIDTH_OPEN = '17%';
export const SIDEBAR_WIDTH_OPEN_CLASS = 'lg:w-[17%]';
export const MAIN_OFFSET_OPEN_CLASS = 'lg:ml-[17%]';

/** Desktop collapsed sidebar width. */
export const SIDEBAR_WIDTH_COLLAPSED = '64px';
export const SIDEBAR_WIDTH_COLLAPSED_CLASS = 'lg:w-[64px]';
export const MAIN_OFFSET_COLLAPSED_CLASS = 'lg:ml-[64px]';
